import React from 'react';
import { flex } from '@fabric-ui/theme';
import { emptyObject } from '@fabric-ui/utils';
import { Box, SxProps } from '@mui/material';
import { ExpandButton } from '../../ModelManagement/ExpandButton';
import SummarizedCollapse from './SummarizedCollapse';
import { ISummarizedCollapse } from './types';

export const entityViewWidgetStyle = { flex: 1, flexShrink: 0 };

type EntityViewWidgetWrapperProps = {
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  summaryItemsProps: ISummarizedCollapse & { sx?: SxProps };
  children: React.ReactNode;
};

export const EntityViewWidgetWrapper: React.FC<EntityViewWidgetWrapperProps> = ({
  isExpanded,
  setIsExpanded,
  summaryItemsProps = { items: [], hideDivider: false, sx: emptyObject },
  children,
}) => (
  <Box
    sx={{
      width: '100%',
      border: `1px solid ${isExpanded ? 'transparent' : 'var(--color-border-interactive-secondary-default)'}`,
      borderRadius: 3,
      transition: theme => theme.transitions.create('border', { duration: theme.transitions.duration.short }),
    }}>
    <Box onClick={() => setIsExpanded(prev => !prev)} sx={{ ...flex.row, gap: 7, p: 1, pr: 3, overflow: 'auto', cursor: 'pointer' }}>
      <Box sx={{ ...flex.itemsCenter, gap: 1, fontWeight: 600 }}>
        <ExpandButton label="Overview" value={isExpanded} style={{ ...flex.row }} />
      </Box>
      {!isExpanded && (
        <Box
          sx={{
            ...flex.justifyBetweenCenter,
            width: '100%',
            opacity: isExpanded ? 0 : 1,
            transition: theme => theme.transitions.create('opacity', { duration: theme.transitions.duration.short }),
            flexWrap: 'wrap',
            overflow: 'hidden',
            gap: 7,
            height: 20,
            ...summaryItemsProps.sx,
          }}>
          <SummarizedCollapse items={summaryItemsProps.items} hideDivider={summaryItemsProps.hideDivider} />
        </Box>
      )}
    </Box>
    {children}
  </Box>
);

export const getKeyValueData = ({ data, dataKey, titleKey, nullValueHeader = 'null' }) =>
  data?.reduce(
    (acc, curr) => ({
      ...acc,
      [curr[titleKey] ?? nullValueHeader]: curr[dataKey],
    }),
    {}
  );
